import { lazy } from "react";

export const ResourceLibraryPageAsync = lazy(() =>
  import("./ResourceLibraryPage").then((module) => ({ default: module.ResourceLibraryPage })),
);
